import { PriceResponse, getPrices } from 'API/payment';
import { useEffect, useState } from 'react';
import useErrorStore from 'stores/error-store';

const usePrices = () => {
  const handleOpenErrorDialog = useErrorStore((state) => state.handleOpenErrorDialog);

  const [prices, setPrices] = useState<PriceResponse>();
  const [loading, setLoading] = useState(false);

  const fetchPrices = async () => {
    setLoading(true);
    const res = await getPrices();

    if (!res.error) {
      setPrices(res);
    } else {
      setPrices(undefined);
      const location = window.location;

      if (location.host === 'app.secret-ai-agent.de') {
        handleOpenErrorDialog(res?.error, '/payments/price', 'get');
      }
    }
    setLoading(false);
  };

  useEffect(() => {
    fetchPrices();
  }, []);

  return { prices, loading, fetchPrices };
};

export default usePrices;
